/* global axios */

const BASE = '/api/v1/ardhisasa/users';
const NRB_BASE = '/api/v1/ardhisasa/nrb';

const authHeaders = (token, jwt) => ({
  'X-Ardhisasa-Token': token,
  'X-Ardhisasa-Jwt': jwt,
});

export const filterByUsername = (token, jwt, username) =>
  axios.get(`${BASE}/filter`, {
    headers: authHeaders(token, jwt),
    params: { username },
  });

export const filterByNationalId = (token, jwt, idNumber) =>
  axios.get(`${BASE}/filter-by-idnumber`, {
    headers: authHeaders(token, jwt),
    params: { id_number: idNumber },
  });

export const filterByCompany = (token, jwt, registrationNumber) =>
  axios.get(`${BASE}/filter-by-company`, {
    headers: authHeaders(token, jwt),
    params: { registration_number: registrationNumber },
  });

export const getCompanyDirectors = (token, jwt, company) =>
  axios.get(`${BASE}/company-directors`, {
    headers: authHeaders(token, jwt),
    params: { company },
  });

export const filterStaff = (
  token,
  jwt,
  { employeeNumber, name, page, pageSize } = {}
) =>
  axios.get(`${BASE}/filter-staff`, {
    headers: authHeaders(token, jwt),
    params: {
      ...(employeeNumber && { employee_number: employeeNumber }),
      ...(name && { name }),
      ...(page && { page }),
      ...(pageSize && { page_size: pageSize }),
    },
  });

export const searchByIdType = (token, jwt, accountNumber, usertype) =>
  axios.get(`${BASE}/search-by-idtype`, {
    headers: authHeaders(token, jwt),
    params: { account_number: accountNumber, usertype },
  });

export const getUserDetails = (token, jwt, userId) =>
  axios.get(`${BASE}/details`, {
    headers: authHeaders(token, jwt),
    params: { user_id: userId },
  });

export const getNrbDetails = (token, jwt, idnum) =>
  axios.get(`${NRB_BASE}/kenyans`, {
    headers: authHeaders(token, jwt),
    params: { idnum },
  });

export const getForeignersDetails = (token, jwt, idnum) =>
  axios.get(`${NRB_BASE}/foreigners`, {
    headers: authHeaders(token, jwt),
    params: { idnum },
  });
